'use strict';

bbw.model.Wall = bbw.model.PubPostsManager.extend({
    
    _getPostsType: function() {
        return 'wall';
    },

    _initSubtypes: function() {
        return this._rpcClient.get('wall/subtypes').execute().then(function(response) {
            this.subtypes = response.subtypes;
            if (bbw.userIsModerator) {
                this.subtypes['unmoderated'] = bbw.messages.unmoderated;
            }
        }.bind(this));
    }

});
